import BookDetail from './BookDetail';

const content = {
  kicker: 'BOOK',
  title: '執事のマナーと教養図鑑',
  lead: '執事の装い、所作、そして英国紳士の教養。全日本執事協会 3代目執事ベルが監修した Gakken の一冊について、監修団体として、各章に何がまとめられているのかをご紹介します。',
  publicationDate: '2026年9月17日 発売',
  breadcrumbs: [{ label: 'ホーム', href: '/' }, { label: '執事のマナーと教養図鑑' }],
  sections: [
    {
      heading: 'この本について / About the Book',
      image: '/images/book/gakken-butler-manners-cover.jpg', imageAlt: 'Gakken刊『執事のマナーと教養図鑑』の表紙', imageContain: true,
      paragraphs: [
        '『執事のマナーと教養図鑑』は、執事という職業に必要な知識を、テーマごとに引ける形でまとめた図鑑です。当協会が監修を務め、池袋にある執事喫茶Swallowtailが協力に加わっています。',
        '協会が大切にしてきたのは、執事の作法を「決まりごと」としてではなく、仕える相手のための振る舞いとして伝えることです。本書も、装い、ふるまい、主人の暮らしを支える教養、そして執事の世界の楽しみ方という順に、職業としての執事の姿を追う構成になっています。',
        '章は4つあり、巻末に執事喫茶Swallowtailのページが加わります。礼装や接遇の基本を確かめたい方、人をもてなす仕事に携わる方、英国の暮らしぶりに関心のある方の、座右の一冊になる内容です。',
      ],
    },
    {
      heading: '第1章 執事の歴史と装いのマナー / History & Dress',
      image: '/images/book/jba-book-ch1-dress-20260915.jpg', imageAlt: '燕尾服とモーニングコート、懐中時計、カフスを配した執事の装いの静物',
      paragraphs: [
        '最初の章のテーマは装いです。はじめに、執事の服になぜ黒が用いられるのかを取り上げています。',
        '執事の服は、主人や客人を引き立てるためのものです。控えめでありながら礼を欠かない黒は、その役割にかなう色です。服の色から「仕える側の装い」という考え方を読み取ることが、礼装を理解する第一歩になります。',
      ],
      subsections: [
        { heading: '時間と場面で変わる礼装', paragraphs: [
          '章の中心は、モーニングコート、タキシード、燕尾服、チェスターコートの4つです。',
          '見本の見開きを見ると、朝から夕方までの正装であるモーニングコートと、夜の正装の中で最も格式の高い燕尾服について、上着の基本の色、ボタンを留めるかどうか、ベストや蝶ネクタイの合わせ方が項目ごとに整理されています。一着ごとの決まりを細部まで確かめられるページです。',
        ] },
        { heading: '懐中時計とカフス', paragraphs: ['懐中時計の種類と扱い方、カフスといった小物も、それぞれ独立した項目として扱われています。袖口や時計を扱う手元は相手から見えやすく、小物への気配りが装いの完成度を左右します。'] },
      ],
    },
    {
      heading: '第2章 執事の美しいふるまいと手入れ術 / Conduct & Care',
      image: '/images/book/jba-book-ch2-conduct-20260915.jpg', imageAlt: '日本人執事が銀のティーポットで紅茶を給仕する手元',
      paragraphs: ['第2章は、執事の動き方をまとめた章です。紅茶とワインの給仕、出迎えのエスコート、物語でもよく描かれるお姫さま抱っこのコツが、所作ごとに解説されています。'],
      subsections: [
        { heading: '給仕', paragraphs: ['給仕の作法は、注ぐ量や器を置く位置などの細かな決まりから成り立っています。その目的は、もてなされる側が食事や会話を心地よく楽しめるよう、給仕の動きを控えめにすることにあります。'] },
        { heading: 'エスコート', paragraphs: ['出迎えのエスコートでは、相手の歩調に合わせ、扉や段差の手前で先に動くことが基本です。相手に余計な気遣いをさせない動きは、来客の案内や目上の方の付き添いでも役立ちます。'] },
        { heading: '銀器と靴の手入れ', paragraphs: ['章の後半は、銀器と靴の手入れです。美しい所作は、手入れの行き届いた道具があってこそ成り立ちます。表からは見えにくい、執事の仕事の土台にあたる部分です。'] },
      ],
    },
    {
      heading: "第3章 執事が知っておくべき英国紳士の教養 / A Gentleman's Culture",
      image: '/images/book/jba-book-ch3-culture-20260915.jpg', imageAlt: 'ウイスキー、チェス、万年筆、蓄音機を配した英国風書斎の静物',
      paragraphs: ['第3章では、執事が仕えてきた英国紳士の文化に目を向けます。ウイスキーとカクテル、文学、音楽、チェス、文具、煙草、そして英国貴族が好んだインテリアまでが取り上げられています。'],
      subsections: [{ heading: '教養が気配りを支える', paragraphs: ['主人の好みや来客との話題を知らなければ、ふさわしい準備はできません。お酒の種類がわかれば器を選べ、話題の背景がわかれば会話を妨げない振る舞いができます。作法の土台には、仕える相手の文化への理解があるということを、この章は英国の暮らしを通して伝えています。'] }],
    },
    {
      heading: '第4章 執事の世界を楽しむ方法 / Enjoying the World of Butlers',
      image: '/images/book/jba-book-ch4-enjoy-20260915.jpg', imageAlt: '洋館サロンのアフタヌーンティーを整えたテーブル',
      paragraphs: ['最後の章は、本の外へ世界を広げるための案内です。国内で英国貴族の世界や執事の仕事ぶりを味わえるスポット、そして執事を描いた作品のおすすめが並んでいます。所作は実際に目で見ることで理解が深まります。本で知ったことを体験で確かめるきっかけになる章です。'],
      subsections: [{ heading: '執事喫茶Swallowtailのページと特典', paragraphs: ['巻末には、執事喫茶Swallowtailのメニューを本の雰囲気に合わせて描いたページと、同店の執事・伊織さんのメッセージが収められています。また、巻末に載っている2次元コードを読み取ると、店名ロゴ入りの壁紙が手に入ります。'] }],
    },
  ],
  bibliographyHeading: '書誌情報',
  bibliography: [
    ['書名', '執事のマナーと教養図鑑'], ['監修', '全日本執事協会'], ['協力', '執事喫茶Swallowtail'],
    ['イラスト', 'ツツイモモエ、ｏｍｉｓｏ'], ['出版社', 'Gakken'], ['発売日', '2026年9月17日'],
    ['判型', '単行本・144ページ'], ['価格', '1,870円(税込)'], ['ISBN', '978-4-05-802760-8'],
  ],
  cta: 'Amazonで見る',
  ctaAriaLabel: 'Amazonで『執事のマナーと教養図鑑』を見る（新しいタブで開く）',
};

const bookLd = {
  '@context': 'https://schema.org', '@type': 'Book', name: '執事のマナーと教養図鑑',
  alternateName: "A British Butler's Guide to Manners and Culture",
  image: 'https://butler-association.jp/images/book/gakken-butler-manners-cover.jpg', inLanguage: 'ja',
  isbn: '9784058027608', numberOfPages: 144, datePublished: '2026-09-17',
  publisher: { '@type': 'Organization', name: 'Gakken' },
  editor: [
    { '@type': 'Organization', '@id': 'https://butler-association.jp/#organization', name: '一般社団法人 全日本執事協会' },
    { '@type': 'Person', '@id': 'https://butlerbell.jp/#person', name: '執事ベル' },
  ],
  contributor: { '@type': 'Organization', name: '執事喫茶Swallowtail' },
  offers: { '@type': 'Offer', price: '1870', priceCurrency: 'JPY', seller: { '@type': 'Organization', name: 'Amazon.co.jp' } },
  '@id': 'https://butler-association.jp/book/butler-manners-and-culture/#book',
  url: 'https://butler-association.jp/book/butler-manners-and-culture/',
};

const breadcrumbLd = {
  '@context': 'https://schema.org', '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'ホーム', item: 'https://butler-association.jp/' },
    { '@type': 'ListItem', position: 2, name: '執事のマナーと教養図鑑', item: 'https://butler-association.jp/book/butler-manners-and-culture/' },
  ],
};

export default function BookPage() {
  return <BookDetail content={content} bookLd={bookLd} breadcrumbLd={breadcrumbLd} />;
}
